/*!
 * 该mixin 主要服务于流程toolbar
 * 
 */
import { loadScript, base64, getElementsByTagName, hasOwnProperty } from 'utils/index'
import api from '@/api/toolbar'
import messageApi from 'utils/messagebox'
import { getContextPath } from 'utils'

const Mixin_Toolbar =  {
  data() {
    return {
      bpmnJsUrl: "/sys/emapflow/public/js/bpmn-viewer.min.js",
      buttons: [],
      buttonsId: [],
      process_status: [],
      formdataClone: this.submitformdata,
      flowcommentClone: this.flowcomment,
      turnbackObj: {  // 退回选人组件默认信息
        customNode: '/sys/emapflow/definition/getAllUserTaskNodes.do',
        customAssigee: '/sys/emapflow/definition/getAssigneesInBpmnByNode.do',
        customHisNodeAndHisPersonNode: '/sys/emapflow/tasks/getHisUserTaskNodes.do',
        customHisNodeAndHisPersonAssignee: '/sys/emapflow/tasks/getHisNodesAssignees.do',
        customHisNodeAndAllPersonNode: '/sys/emapflow/tasks/getHisUserTaskNodes.do',
        customHisNodeAndAllPersonAssignee: '/sys/emapflow/definition/getAssigneesInBpmnByNode.do',
        nodelabel: this.$LocalH5('toolbar.goBackTo'),
        assigneeslabel: this.$LocalH5('toolbar.handledBy')
      },
      turnbackValue: {}
    }
  },
  props: {
    defkey: String,
    taskid: String,
    processinstanceid: String,
    circulateid: String,
    distributetaskid: String,
    submitformdata: Object,
    flowcomment: [String,Object],
    onverify: Function,
    onbtnrender: Function,
    onquerysetting: Function,
    formsubmiturl: String,
    formsubmit: Boolean,
    closemessageinfo: Boolean
  },
  watch: {
    flowcomment: {
      handler: function(newVal) {
        this.flowcommentClone = newVal;
      },
      deep: true
    },
    submitformdata: {
      handler: function(newVal) {
        this.formdataClone = newVal;
      },
      deep: true
    }
  },
  methods: {
    /** 临时兼容代码 start **/
    do_start(item) { 
      this.doCommonRequest(item)
    },
    do_submit(item) { 
      this.doCommonRequest(item)
    },
    do_termination(item) {
      this.doCommonRequest(item)
    },
    do_turnback(item) {
      this.doCommonRequest(item)
    },
    do_callback(item) {
      this.doCommonRequest(item)
    },
    do_custom(item) {
      this.doCommonRequest(item)
    },
    do_change_assignee(item) {
      this.doCommonRequest(item)
    },
    do_process_status(item) {
      this.doCommonRequest(item)
    },
    do_process_track(item) {
      this.doCommonRequest(item)
    },
    do_addAssigneeTask(item) {
      this.doCommonRequest(item)
    },
    do_deleteAssigneeTask(item) {
      this.doCommonRequest(item)
    },
    do_urgent(item) {
      this.doCommonRequest(item)
    },
    do_already_read(item) {
      this.doCommonRequest(item)
    },
    /** 临时兼容代码 end **/
    doCommonRequest(item) {
      let query;
      switch (item.execute) {
        case 'do_start':
          if (!this.hasDefKey()) throw new Error(item.commandType + "动作参数不满足，defKey没有传入");
          query = this.getQuery(item);
          break;
        case 'do_submit':
        case 'do_termination':
        case 'do_turnback':
        case 'do_callback':
        case 'do_change_assignee':
        case 'do_custom':
        case 'do_process_track': 
          if(item.execute === "do_custom") item.commandType = "custom";
          if (!this.hasTaskID()) throw new Error(item.commandType + "动作参数不满足，taskid没有传入");
          query = this.getQuery(item);
          // 退回 -- 自定义选择节点特别处理 2020/7/13 需求提出： 王志伟
          if(item.execute == 'do_turnback' && item.nextAssignees ) {
            query.nextAssignees = item.nextAssignees;
          }
          break;
        case 'do_process_status':
          query =  {
            defKey: this.defkey,
            taskId: this.taskid,
            responseType:'JSON'
          };
          break;
        case 'do_addAssigneeTask':
        case 'do_deleteAssigneeTask': 
          query = {
            "taskId":  item.taskId,
            "assignee": item.assignees,
            "defKey": this.defkey
          };
          break;
        case 'do_urgent':
          query = {
            "taskId":  this.taskid,
            "formData": JSON.stringify(item.formdata)
          };
          break;
        case 'do_already_read': 
          query = {
            "defKey":  this.defkey,
            "circulateTaskId": this.circulateid
          };
          break;
        case 'do_distribute_submit': 
          query = {
            distributeDesc: item.distributeDesc,
            messageType: item.messageType,
            toUsers: item.toUsers,
            processInstanceId: this.processinstanceid || '',
            taskId: this.taskid
          };
          break;
        case 'do_distribute_opinions':
          item = this.getQuery(item);
          query = {
            distributeTaskId: this.distributetaskid || item.distributeTaskId,
            replyComment: item.replyComment,
            attachId: item.attachId
          };
          break;
        default:
          throw Error(`The execute (${item.execute}) is undefined`);
      }
      // 超大post请求体form表单模拟提交
      let len = JSON.stringify(query).length/1024/1024;
      if(this.formsubmit && len > 1) {
        // form表单提交，返回结果监听构建
        this.watchFormSubmit(item);
        // form提交构建
        const formNode = this.$refs["multipart_form"];
        if(!this.formsubmiturl) {
          formNode.action = getContextPath() + (query.url || api.urlObj.commands[query.execute]);
        }
        let nodes = formNode.childNodes;
        for (let i = nodes.length - 1; i >= 0; i--) {
          let node = nodes[i];
          formNode.removeChild(node);
        }
        let input;
        for (let key in query) {
          input = document.createElement('input');
          input.type = "hidden";
          input.name = key;
          input.value = query[key];
          formNode.appendChild(input);
        }
        formNode.submit();
        this.$emit('loading',false)
      } else {
        return new Promise(resolve => {
          api.execCommand(item.execute, query).then(([response, wholeResponse]) => {
            if(response.msg) {
              if(!this.closemessageinfo) {
                messageApi(response.msg , 'error');
              }
              this.buttons = this.buttons.map(item => {
                item.disabled = false;
                return item
              });
              this.$emit('loading',false)
            }else{
              this.doResponse(item, response, wholeResponse);
              resolve(response, wholeResponse);
            }
          }).catch(()=>{
            this.$emit('loading',false)
          })
        })
      }
    },
    doResponse(item, response, wholeResponse) {
      switch(item.commandType) {
        case 'start':
        case 'draft':
        case 'submit':
        case 'termination':
        case 'turnback':
        case 'callback':
        case 'changeAssignee':
        case 'custom':
        case 'alreadyRead':
        case 'distributeSubmit':
        case 'distributeOpinions':
          this.$emit("action_complete", item.commandType, wholeResponse, response);
          if(!this.closemessageinfo) {
            messageApi(this.$LocalH5('toolbar.actionSuccess',{action:item.name}) , 'success');
          }
          break; 
        case 'processStatus':
          this.process_status = response;
          this.$emit("action_complete", item.commandType, wholeResponse, response);
          break;
        case 'processTrack':
          this.renderProcessTrack(response);
          this.$emit("action_complete", item.commandType, wholeResponse, response);
          break;
        case 'addAssigneeTask':
        case 'deleteAssigneeTask':
        case 'urgent':
          this.$emit("action_complete", item.commandType, wholeResponse, response);
          break;
        default:
          break;
      }
    },
    turnbackNodeResponse (res) {
      return res.items || []
    },
    // 绘制轨迹
    renderProcessTrack(data) {
      if(data && data.datas && data.datas.bpmnXml) {
        let bpmnXml = data.datas.bpmnXml;
        this.$nextTick(function(){
          if(!window.BpmnJS) {
            let contextPath = getContextPath();
            const _this = this;
            loadScript(window.location.origin + contextPath + this.bpmnJsUrl, function() {
              _this.canvasBpmnViewer(bpmnXml, data.datas)
            })
          }else{
            this.canvasBpmnViewer(bpmnXml, data.datas)
          }
        })
      }
    },
    /**
     * @method getQuery
     * @description 获取当前操作请求参数, formData必须存在，flowComment仅在taskid为空，即启动时存在。其中涉及formdata,flowcomment数据处理，该部分处理将在2.x版本中废弃，统一使用外置方法onquerysetting由开发者统一处理。
     * @param {Object} btn - 当前操作按钮行为信息
     * return {Object} query - 请求参数
     */
    getQuery(btn) {
      let item = Object.assign({}, btn);
      try {
        delete item.disabled;
        delete item.buttonType
        delete item.color;
        delete item.className;
      } catch (error) {
        /* Ignore */
      }
      // 处理formdata数据
      let formdata = {};
      if(this.formdataClone) formdata = JSON.parse(JSON.stringify(this.formdataClone));
      // 处理审批意见组件数据
      let flowcomment = "";
      if(this.flowcommentClone) {
        if(typeof this.flowcommentClone === "string") {
          flowcomment = this.flowcommentClone
        } else {
          // 1.x 数据格式【｛"flowComment": 'xxx', "elecsealUrl": 'xxx', "approval": 'xxx'｝】
          // 2.x 数据格式【｛"approval": 'xxx', "approval_display": 'xxx', "comment": 'xxx', "elecseal": 'xxx'｝】
          if(hasOwnProperty(this.flowcommentClone, 'flowComment')) {
            flowcomment = this.flowcommentClone.approval
              ? (this.flowcommentClone.flowComment ? (this.flowcommentClone.approval + "," + this.flowcommentClone.flowComment): this.flowcommentClone.approval)
              : this.flowcommentClone.flowComment;
            formdata.elecseal = this.flowcommentClone.elecsealUrl;
            formdata.approval = this.flowcommentClone.approval;
          } else {
            flowcomment = this.flowcommentClone.approval_display 
              ? (this.flowcommentClone.comment ? (this.flowcommentClone.approval_display  + ',' + this.flowcommentClone.comment) : this.flowcommentClone.approval_display)
              : this.flowcommentClone.comment;
            if(hasOwnProperty(this.flowcommentClone, 'elecseal')) formdata.elecseal = this.flowcommentClone.elecseal;
            if(hasOwnProperty(this.flowcommentClone, 'approval_display')) formdata.approval = this.flowcommentClone.approval_display;
          }
        }
      }
      let query = Object.assign(
        {}, 
        item,
        {
          taskId: this.taskid || '',
          defKey: this.defkey || '',
          formData: JSON.stringify(formdata)
        }
      );
      if(item.commandType !== 'start') query.flowComment = flowcomment;
      if(this.onquerysetting !== undefined) query = this.onquerysetting(query);
      return query
    },
    /**
     * @method hasTaskID
     * @description 判断是否存在taskid
     * return {Boolean}
     */
    hasTaskID: function() {
      return !(this.taskid == null || this.taskid === "" || this.taskid === "null");
    },
    /**
     * @method hasDefKey
     * @description 判断是否存在defkey
     * return {Boolean}
     */
    hasDefKey: function() {
      return !(this.defkey == null || this.defkey === "" || this.defkey === "null");
    },
    hasStringbuteId: function() {
      return !(this.distributetaskid == null || this.distributetaskid === "" || this.distributetaskid === "null");
    },
    /**
     * @method watchFormSubmit
     * @description 监听formsubmit返回数据
     * @param {btn} 命令按钮信息
     */
    watchFormSubmit(btn) {
      const iframe = document.getElementById('upload_pipe');
      const _this = this;
      if (iframe.attachEvent) {
        iframe.attachEvent("onload", function() {
          _this.dealWithContent(btn, iframe)
        });
      } else {
        iframe.onload = function() {
          _this.dealWithContent(btn, iframe)
        };
      }
    },
    dealWithContent(btn, iframe) {
      let content = iframe.contentWindow.document.body.innerHTML;
      content = content.match(/{.*}/g) ? content.match(/{.*}/g)[0] : null;
      if(!this.closemessageinfo) {
        if(content) {
          let data = JSON.parse(content);
          if (data.succeed || data.code === "0") {
            messageApi(this.$LocalH5('toolbar.actionSuccess',{action:btn.name}), 'success');
          } else {
            this.buttons = this.buttons.map(item => {
              item.disabled = false;
              return item
            });
            messageApi(this.$LocalH5('toolbar.actionFailed',{action:btn.name}), 'error');
          }
        }else{
          messageApi(this.$LocalH5('toolbar.actionFailed',{action:btn.name}), 'error');
        }
      }
      this.$emit("action_complete", btn.commandType, content, 'formsubmit');
    },
    /**
     * @method canvasBpmnViewer
     * @description 绘制Bpmn视图(canvas)
     * @param {xml} bpmnXml - bpmn流程图xml
     * @param {Object} record - 绘图信息数据
     */
    canvasBpmnViewer(bpmnXml, record) {
      const _this = this;
      this.$refs["js-canvas"].innerHTML = '';
      let viewer = new window.BpmnJS({
        container: this.$refs["js-canvas"]
      });
      let xml = base64.decode(bpmnXml);
      viewer.importXML(xml, function(err) {
        if(!err) {
          // 节点着色
          _this.repaintSVGColor(viewer, record);
          // 调整容器宽高
          let SVG_G = document.getElementsByClassName("viewport");
          if(SVG_G && SVG_G.length) {
            SVG_G = SVG_G[0];
            _this.$refs["js-canvas"].style.width = SVG_G.getBBox().width + 'px'
          }
          // 解决部分手机浏览器中结束节点无法渲染的问题
          if(document.getElementsByClassName("bpmn-endevent").length){
            let transform = document.getElementsByClassName("bpmn-endevent")[0].getAttribute("transform");
            document.getElementsByClassName("bpmn-endevent")[0].setAttribute("transform",transform);
          }
        }
      })
    },
    /**
     * @method repaintSVGColor
     * @description 绘制Bpmn视图中svg图的颜色
     * @param {Object} viewer - 视图对象
     * @param {Object} record - 绘图信息数据
     */
    repaintSVGColor(viewer, record) {
      const canvas = viewer.get('canvas');
      const elementRegistry = viewer.get('elementRegistry');
      elementRegistry.getAll().forEach((item) => {
        canvas.addMarker(item, item.type.toLowerCase().replace(/:/, "-"));
        if (record.historicActivityIds.indexOf(item.id) > -1) {
          canvas.addMarker(item, item.type.toLowerCase().replace(/:/, "-") + "-passed");
        }
        if (record.historicFlows.indexOf(item.id) > -1) {
          canvas.addMarker(item, item.type.toLowerCase().replace(/:/, "-") + "-passed");
        }
        if (record.activeActivityIds.indexOf(item.id) > -1) {
          canvas.addMarker(item, item.type.toLowerCase().replace(/:/, "-") + "-actived");
        }
      });
      this.repaintArrowColor('sequenceflow-end', 'rgb(88,88,88)');
      this.repaintArrowColor('sequenceflow-end-passed', 'rgb(205,213,224)');
    },
    /**
     * @method repaintArrowColor
     * @description 绘制svg图中线条/箭头的颜色
     * @param {String} id - 着色箭头的id
     * @param {String} color - rgb
     */
    repaintArrowColor(id,color) {
      let path = document.createElementNS( "http://www.w3.org/2000/svg", "path" );
      path.setAttribute( "d", "M 1 5 L 11 10 L 1 15 Z" );
      path.setAttribute( "style", "fill: "+ color +"; stroke-width: 1px; stroke-linecap: round; stroke-dasharray: 10000, 1; stroke: "+ color +";" );
          
      var marker = document.createElementNS( "http://www.w3.org/2000/svg", "marker" );
      marker.setAttribute( "id", id );
      marker.setAttribute( "viewBox", "0 0 20 20" );
      marker.setAttribute( "refX", 11 );
      marker.setAttribute( "refY", 10 );
      marker.setAttribute( "markerWidth", 10 );
      marker.setAttribute( "markerHeight", 10 );
      marker.setAttribute( "orient", "auto" );
      marker.appendChild( path );

      var svg = document.getElementsByClassName('bpmn-process')[0];
      var defs = getElementsByTagName(svg, 'defs')[0];
      defs.appendChild(marker);
    }
  },
  created() {
    let params = {}, 
        exclude_type = "";
    if (this.hasTaskID() || this.hasStringbuteId()) {
      exclude_type = "start";
      params = {
        taskId: this.taskid,
        circulateTaskId: this.circulateid,
        distributeTaskId: this.distributetaskid
      };
    } else if (!this.hasTaskID() && this.hasDefKey()) {
      exclude_type = "submit";
      params = {
        defKey: this.defkey
      };
    } else {
      throw new Error("toolbar渲染，参数不满足，taskid or defkey 都没有传入");
    }
    api.getToolbarBtns(exclude_type, params).then(response => {
      let btns = response.commands.map(cmd => {
        if(cmd.name === '提交(启动)') cmd.name = '提交';
        return cmd;
      });
      if (this.onbtnrender !== undefined) {
        btns = this.onbtnrender(btns, this);
      }
      let mainbtn = [];
      btns = btns.filter(item => {
        if((item.commandType === "start" || item.commandType === "submit") && item.commandType !== exclude_type) {
          mainbtn.push(item);
        }
        if(item.commandType === "processTrack" && !window.BpmnJS) {
          if (!window.location.origin) {
            window.location.origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port: '');
          }
          const contextPath = this.contextPath || getContextPath();
          loadScript(window.location.origin + contextPath + this.bpmnJsUrl, function() {})
        }
        return item.commandType !== "start" && item.commandType !== "submit";
      });
      btns = mainbtn.concat(btns);
      this.buttons = btns;
      this.buttonsId = btns.map( btn => {
        return btn.id
      })
    })
  }
};

export default Mixin_Toolbar